import React, { Component } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { 
  decreaseStepByOne 
} from "../../../actions";
import { 
  numberWithDots
} from "../../../helpers";

import aptoIcon from '../../../assets/icons/hogar/ic_sml_apto.png';
import homeIcon from '../../../assets/icons/hogar/ic_sml_home.png';
import firstFloorIcon from '../../../assets/icons/hogar/ic_sml_1.png';
import secondFloorIcon from '../../../assets/icons/hogar/ic_sml_2.png';
import fireIcon from '../../../assets/icons/hogar/ic_sml_fire.png';
import theftIcon from '../../../assets/icons/hogar/ic_sml_robo.png';

class SelectedAnswers extends Component {
  render() {
    const {
      houseType,
      aptoFloors,
      fireSelected,
      theftSelected,
      goBack
    } = this.props;

    return (
      <div className="SelectedAnswers">
        <div className="SelectedAnswers-answer-button" onClick={() => {goBack(theftSelected ? 3 : (fireSelected ? 2 : 1))}}>
          <span className="SelectedAnswers-answer-content"> 
            <img 
              src={houseType === 'A' ? aptoIcon : homeIcon} 
              className="SelectedAnswers-answer-icon" alt="Tipo de propiedad"
            />
            {houseType === 'A' ? 'Apartamento' : 'Casa'}
          </span>
          <span className="SelectedAnswers-answer-cross">x</span>
        </div>
        { houseType === 'A' &&
          <div className="SelectedAnswers-answer-button" onClick={() => {goBack(theftSelected ? 3 : (fireSelected ? 2 : 1))}}>
            <span className="SelectedAnswers-answer-content"> 
              <img 
                src={aptoFloors === 1 ? firstFloorIcon : secondFloorIcon} 
                className="SelectedAnswers-answer-icon" alt="Cantidad de pisos"
              /> 
              {aptoFloors === 1 ? 'Primer Piso' : 'Segundo o superior'}
            </span>
            <span className="SelectedAnswers-answer-cross">x</span>
          </div>
        }
        { fireSelected &&
          <div className="SelectedAnswers-answer-button" onClick={() => {goBack(theftSelected ? 2 : 1)}}>
            <span className="SelectedAnswers-answer-content"> 
              <img 
                src={fireIcon} 
                className="SelectedAnswers-answer-icon" alt="Monto por incendio"
              /> 
              { 'U$S ' + numberWithDots(fireSelected.Value) }
            </span>
            <span className="SelectedAnswers-answer-cross">x</span>
          </div>
        }
        { theftSelected &&
          <div className="SelectedAnswers-answer-button" onClick={() => {goBack()}}>
            <span className="SelectedAnswers-answer-content"> 
              <img 
                src={theftIcon} 
                className="SelectedAnswers-answer-icon" alt="Monto por robo"
              /> 
              { 'U$S ' + numberWithDots(theftSelected.Value) }
            </span>
            <span className="SelectedAnswers-answer-cross">x</span>
          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    houseType: state.home.houseType,
    aptoFloors: state.home.aptoFloors,
    fireSelected: state.home.fireSelected,
    theftSelected: state.home.theftSelected
  };
};

const mapDispatchToProps = dispatch => {
  return {
    goBack: (count = 1) => {
      dispatch(decreaseStepByOne());
      if(count > 1) dispatch(decreaseStepByOne());
      if(count > 2) dispatch(decreaseStepByOne());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectedAnswers);
